import React, { useCallback, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import QCXComponentesFreteFormGroup from '../componentes-frete-form-group/QCXComponentesFreteFormGroup';
import QCXFinalCheckboxField from '../final-checkbox-field/QCXFinalCheckboxField';
import QCXFinalAlternativeCurrencyField from '../final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectMoedaAutocomplete from '../final-select-moeda-field/QCXSelectMoedaAutocomplete';
import { normalizeNumeral, unnormalizeNumeral } from '../../utils/general/general-utils';

export default function QCXMoedaFreteDuimpFormGroup({
  isConsult,
  handleValorNaMoedaOnBlur,
  valorValidators,
  intl,
  classes,
}) {
  const { t } = useTranslation();

  const form = useForm();
  const { values } = useFormState();

  const componentesFreteListRootName = 'atributosAdicionais.componentesFrete';
  const componentesFrete = _.get(values, componentesFreteListRootName);
  const isMaritimo = values?.atributosAdicionais?.transporte?.viaTransporte?.code === '01';
  const possuiComponentesFrete = componentesFrete?.length > 0;

  const fretePrepaidMoedaName = possuiComponentesFrete ? 'frete.valorMoedaPrepaidOriginal' : 'frete.valorMoedaPrepaid';
  const fretePrepaidRealName = possuiComponentesFrete ? 'frete.valorRealPrepaidOriginal' : 'frete.valorRealPrepaid';

  const freteCollectMoedaName = possuiComponentesFrete ? 'frete.valorMoedaCollectOriginal' : 'frete.valorMoedaCollect';
  const freteCollectRealName = possuiComponentesFrete ? 'frete.valorRealCollectOriginal' : 'frete.valorRealCollect';

  return (
    <>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <QCXSelectMoedaAutocomplete
          id="select-field-moeda-frete"
          key="select-field-moeda-frete"
          name="frete.moeda.id"
          label={t('com.muralis.qcx.frete.moedaFreteInternacional')}
          disabled={isConsult}
          initialValues={values}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4}>
        <QCXFinalAlternativeCurrencyField
          id="currency-valor-moeda-frete-prepaid-field"
          key="currency-valor-moeda-frete-prepaid-field"
          name={fretePrepaidMoedaName}
          validate={valorValidators}
          onBlur={handleValorNaMoedaOnBlur(
            form,
            values,
            'frete.moeda',
            'frete.valorMoedaPrepaid',
            'frete.valorRealPrepaid'
          )}
          label={t('com.muralis.qcx.frete.valorFretePrepaidMoeda')}
          disabled={isConsult || !values?.frete?.moeda?.id}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <QCXFinalAlternativeCurrencyField
          id="currency-valor-real-moeda-frete-prepaid-field"
          key="currency-valor-real-moeda-frete-prepaid-field"
          name={fretePrepaidRealName}
          label={t('com.muralis.qcx.frete.valorFretePrepaidReais')}
          intl={intl}
          adorned
          disabled
          helperText={!isConsult && t('com.muralis.qcx.mensagem.arredondamentoValor')}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4}>
        <QCXFinalCheckboxField
          id="checkbox-frete-embutir-item-field"
          key="checkbox-frete-embutir-item-field"
          name="frete.embutirItem"
          label={t('com.muralis.qcx.frete.embutirFreteItens')}
          disabled={isConsult}
        />
      </Grid>
      <Grid item className={classes.moedaInternacionalFieldLeft} xs={12} sm={12} md={4} lg={4}>
        <QCXFinalAlternativeCurrencyField
          id="currency-valor-moeda-frete-collect-field"
          key="currency-valor-moeda-frete-collect-field"
          name={freteCollectMoedaName}
          onBlur={handleValorNaMoedaOnBlur(
            form,
            values,
            'frete.moeda',
            'frete.valorMoedaCollect',
            'frete.valorRealCollect'
          )}
          label={t('com.muralis.qcx.frete.valorFreteCollectMoeda')}
          validate={valorValidators}
          disabled={isConsult || !values?.frete?.moeda?.id}
        />
      </Grid>
      <Grid item className={classes.moedaInternacionalFieldRight} xs={12} sm={12} md={4} lg={4}>
        <QCXFinalAlternativeCurrencyField
          id="currency-valor-real-moeda-frete-collect-field"
          key="currency-valor-real-moeda-frete-collect-field"
          name={freteCollectRealName}
          label={t('com.muralis.qcx.frete.valorFreteCollectReais')}
          intl={intl}
          adorned
          disabled
          helperText={!isConsult && t('com.muralis.qcx.mensagem.arredondamentoValor')}
        />
      </Grid>

      {isMaritimo && possuiComponentesFrete ? (
        <>
          <Grid item xs={12} sm={12} md={4} lg={4} />
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <QCXFinalAlternativeCurrencyField
              id="currency-valor-moeda-frete-componentes-total"
              key="currency-valor-moeda-frete-componentes-total"
              name="frete.valorMoedaFreteComponentesTotal"
              label="Valor total do Frete + Componentes na Moeda"
              intl={intl}
              adorned
              disabled
              helperText={!isConsult && t('com.muralis.qcx.mensagem.arredondamentoValor')}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <QCXFinalAlternativeCurrencyField
              id="currency-valor-real-frete-componentes-total"
              key="currency-valor-real-frete-componentes-total"
              name="frete.valorRealFreteComponentesTotal"
              label="Valor total do Frete + Componentes em Reais"
              intl={intl}
              adorned
              disabled
              helperText={!isConsult && t('com.muralis.qcx.mensagem.arredondamentoValor')}
            />
          </Grid>
        </>
      ) : null}

      <Grid item xs={12} sm={12} md={4} lg={4} />
      <Grid item className={classes.moedaInternacionalFieldLeft} xs={12} sm={12} md={4} lg={4}>
        <QCXFinalAlternativeCurrencyField
          id="currency-valor-moeda-frete-territorio-nacional-field"
          key="currency-valor-moeda-frete-territorio-nacional-field"
          name="frete.valorFreteNacionalMoeda"
          validate={valorValidators}
          onBlur={handleValorNaMoedaOnBlur(
            form,
            values,
            'frete.moeda',
            'frete.valorFreteNacionalMoeda',
            'frete.valorFreteNacionalReal'
          )}
          label={t('com.muralis.qcx.frete.valorFreteNacionalMoeda')}
          disabled={isConsult || !values?.frete?.moeda?.id}
        />
      </Grid>
      <Grid item className={classes.moedaInternacionalFieldRight} xs={12} sm={12} md={4} lg={4}>
        <QCXFinalAlternativeCurrencyField
          id="currency-valor-real-moeda-frete-territorio-nacional-field"
          key="currency-valor-real-moeda-frete-territorio-nacional-field"
          name="frete.valorFreteNacionalReal"
          label={t('com.muralis.qcx.frete.valorFreteNacionalReais')}
          intl={intl}
          adorned
          disabled
          helperText={!isConsult && t('com.muralis.qcx.mensagem.arredondamentoValor')}
        />
      </Grid>

      {isMaritimo ? (
        <QCXComponentesFreteFormGroup
          listRootName={componentesFreteListRootName}
          isConsult={isConsult}
        />
      ) : null}
    </>
  );
}
